import script from "./flash.vue?vue&type=script&setup=true&lang=ts"
export * from "./flash.vue?vue&type=script&setup=true&lang=ts"

import "./flash.vue?vue&type=style&index=0&id=975e17ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-975e17ae"]])

export default __exports__